<template>
  <closeable-filter-badge-container
    class="filter-menu-element px-3 hover:bg-primary-light hover:text-primary-focus"
    @remove="onRemove"
  >
    <list-filter-value :labels="marketLabels"
                       :options="marketOptions"
                       label-full="All markets"
                       label-empty="No markets selected"
                       class="gap-2"
    >
      <template>
        <vs-icon icon="storefront" class="mr-1"/>
      </template>
    </list-filter-value>
  </closeable-filter-badge-container>
</template>

<script>
import CloseableFilterBadgeContainer from './CloseableFilterBadgeContainer.vue'
import ListFilterValue from '@/components/analytics/filter/ListFilterValue'
import { FILTER_ITEMS } from '@/utils/filter.constants'

export default {
  name: 'MarketsFilterBadge',

  props: {
    markets: {
      validator: value => value === null || Array.isArray(value),
      default: null
    },
    marketOptions: {
      type: Array,
      required: true
    }
  },

  components: {
    CloseableFilterBadgeContainer,
    ListFilterValue
  },

  computed: {
    marketLabels() {
      if (this.markets === null) {
        return this.marketOptions.map(({ name }) => name)
      }

      const selectedOptions = this.selectedMarkets
      if (selectedOptions.length > 1 && selectedOptions.length !== this.marketOptions.length) {
        return [`${selectedOptions.length} markets`]
      }
      return selectedOptions.map(({ name }) => name)
    },

    selectedMarkets() {
      if (this.markets === null) return []

      return this.marketOptions.filter(
        ({ id }) => this.markets.includes(id)
      )
    }
  },

  methods: {
    onRemove() {
      this.$emit('remove', { [FILTER_ITEMS.MARKETS]: null })
    }
  }
}
</script>
